<template>
    <span :class="`text-wrapper${isArea ? ' text-wrapper--textarea' : ''}`">
        <textarea v-if="isArea"
                  :class="`form__field form__field--textarea ${(this.def ? `form__field--${this.def} --${this.def} js-${this.def}` : '' )}`"
                  :name="def" :id="def" :ref="def"
                  :placeholder="placeholder"
                  :value="internalValue"
                  :readonly="readOnly"
                  :disabled="disabled"
                  @input="onInput"
                  @change="onChange"
                  @keydown="$emit('keydown', $event)"
                  @keypress="$emit('keypress', $event)"
                  @keyup="$emit('keyup', $event)"
                  @keyup.enter="$emit('keyup.enter', $event)"
                  @mousedown="$emit('mousedown', $event)"
                  @mouseover="$emit('mouseover', $event)"
                  @mouseup="$emit('mouseup', $event)"
                  @touchstart="$emit('touchstart', $event)"
                  @touchend="$emit('touchend', $event)"
                  @touchcancel="$emit('touchcancel', $event)"
                  @blur="onBlur" />
        <input v-else
               type="text"
               :class="`form__field form__field--textbox ${(this.def ? `form__field--${this.def} --${this.def} js-${this.def}` : '' )}`"
               :name="def" :id="def" :ref="def"
               :placeholder="placeholder"
               :value="internalValue"
               :readonly="readOnly"
               :disabled="disabled"
               @input="onInput"
               @change="onChange"
               @keydown="$emit('keydown', $event)"
               @keypress="$emit('keypress', $event)"
               @keyup="$emit('keyup', $event)"
               @keyup.enter="$emit('keyup.enter', $event)"
               @mousedown="$emit('mousedown', $event)"
               @mouseover="$emit('mouseover', $event)"
               @mouseup="$emit('mouseup', $event)"
               @touchstart="$emit('touchstart', $event)"
               @touchend="$emit('touchend', $event)"
               @touchcancel="$emit('touchcancel', $event)"
               @blur="onBlur">
    </span>
</template>

<script>

import FormControlText from './form-control-text'

export default {

    props: {
        isArea: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [
        FormControlText,
    ],
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.form {

    @include element('field') {

        @include modifier('textarea') {
            @include read-only-field;
        }

        @include modifier('textbox') {
            @include read-only-field;
        }
    }
}

.text-wrapper {

    @include modifier('textarea') {

        @include bp-min-small {
            display: block;
            width: 100%;
        }
    }
}

</style>
